// @ts-ignore
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Society } from 'types';

type TableToExcelButtonsProps = {
  actualSociety: Society;
  isPartnerBookVisible: boolean;
};

const TableToExcelButtons: FC<TableToExcelButtonsProps> = ({
  actualSociety,
  isPartnerBookVisible,
}) => {
  const { t } = useTranslate();

  if (!isPartnerBookVisible) {
    return null;
  }

  return (
    <>
      <ReactHTMLTableToExcel
        id="comercialBtn"
        className="d-none"
        table="partnersRegisterTable"
        filename={`${t('RegisterBook')} - ${actualSociety?.name}`}
        sheet="Libro Registro de Socios"
        buttonText={`${t('Download')}`}
        buttonComponent={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <button type="button" className="btn btn-white btn-outline-light">
            <em className="icon ni ni-file-download" />
          </button>
        }
      />

      <ReactHTMLTableToExcel
        id="summaryBtn"
        className="d-none"
        table="partnerClassTable"
        filename={`${t('Summary')} - ${actualSociety?.name}`}
        sheet="Libro Registro de Socios"
        buttonText={`${t('Download')}`}
        buttonComponent={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <button type="button" className="btn btn-white btn-outline-light">
            <em className="icon ni ni-file-download" />
          </button>
        }
      />

      <ReactHTMLTableToExcel
        id="summaryAccumulatedBtn"
        className="d-none"
        table="partnerClassTableInversion"
        filename={`${t('Summary')} - ${actualSociety?.name}`}
        sheet="Libro Registro de Socios"
        buttonText={`${t('Download')}`}
        buttonComponent={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <button type="button" className="btn btn-white btn-outline-light">
            <em className="icon ni ni-file-download" />
          </button>
        }
      />

      <ReactHTMLTableToExcel
        id="summaryInvestorsBtn"
        className="d-none"
        table="partnerClassTableInvestors"
        filename={`${t('SummaryInvestors')} - ${actualSociety?.name}`}
        sheet="Libro Registro de Socios"
        buttonText={`${t('Download')}`}
        buttonComponent={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <button type="button" className="btn btn-white btn-outline-light">
            <em className="icon ni ni-file-download" />
          </button>
        }
      />
    </>
  );
};

export default TableToExcelButtons;
